export default __webpack_public_path__ + "static/18_18-785ebe182de2ff337ff5a0a71475b62d.png";